// Image imports
import abrahamMunderPortrait from '../../../images/abraham-munder.jpeg';

export const abrahamMunderMemorial = {
  id: 18,
  name: 'Abraham Munder',
  category: 'community-leaders',
  images: {
    portrait: abrahamMunderPortrait
  },
  info: `

"You were abandoned, again and again, by the prime minister and his ministers, to Hamas's tunnels." - Keren Munder, daughter of Abraham

# Abraham Munder

![Abraham Munder](${abrahamMunderPortrait})
*Abraham Munder, whose family's story embodies both tragedy and resilience*

## A Kibbutz Patriarch

Abraham Munder was 79 years old when Hamas terrorists attacked Kibbutz Nir Oz on October 7th, 2023. A longtime resident of the kibbutz, Abraham was a beloved figure in the community - a father, grandfather, and friend known for his kindness and wisdom.

That morning, Abraham was taken hostage along with his daughter Keren and his nine-year-old grandson Ohad. For 49 days, the three generations of the Munder family were held captive together - a shared ordeal that would end differently for each of them.

## A Family Divided

In November 2023, during a temporary ceasefire, Keren and Ohad were released and returned to Israel, but Abraham remained in captivity. In a cruel twist of fate, father and daughter were separated, with Keren forced to leave her father behind in Gaza.

For the next nine months, Keren became a powerful voice advocating for her father's release and that of all remaining hostages. Having experienced captivity herself, she spoke with unique authority about the conditions and the urgent need to bring everyone home.

## A Life of Building

Before retirement, Abraham had been a builder - both literally in his work in construction and figuratively in his dedication to his kibbutz and community. Friends recall how he would always be the first to offer help with home repairs or improvement projects around the kibbutz.

Abraham was known for his garden, which he tended with patience and care. His vegetables were shared freely with neighbors, and his flavorful tomatoes were particularly prized at kibbutz gatherings.

"My father could make things grow in the desert," Keren once said. "He understood that with enough care and attention, life can flourish even in the harshest conditions."

## A Final Heartbreak

On August 8, 2024, Israeli forces recovered Abraham's body along with five other elderly hostages from Gaza. All had died in captivity, though the exact circumstances of their deaths remain unclear.

Keren, who had survived her own captivity only to lose her father, spoke at his funeral with both grief and anger. "You were abandoned," she said, addressing her father while castigating Israeli leadership for failing to secure a deal that might have saved his life.

The funeral was held in Kibbutz Nir Oz, where distant explosions and gunfire could be heard - a stark reminder of the ongoing conflict that had claimed Abraham's life.

## A Grandson's Memory

Perhaps the most poignant aspect of Abraham's story is seen through the eyes of his grandson Ohad, who had shared those 49 days of captivity with his grandfather. At just nine years old, Ohad had witnessed courage and resilience in his grandfather that few children ever see.

"Grandpa told me stories to keep me from being scared," Ohad shared at the funeral. "He said we had to be brave for Mom."

In honor of Abraham, his family has established a foundation to support the mental health needs of children affected by the October 7th attacks, ensuring that young people like Ohad receive the care they need to process their trauma.

May his memory be a blessing, and may his family find the peace that was taken from him.

`
};